import { ApiAdminUsersResponseData } from './types';
import { AdminUser } from '..';

export class AdminUsersData {
  readonly count: number;
  readonly users: AdminUser[];

  constructor(private readonly apiUsersResponse: ApiAdminUsersResponseData) {
    this.count = apiUsersResponse.count;
    this.users = this.toUsersData();
  }

  private toUsersData(): AdminUser[] {
    const apiUsers = this.apiUsersResponse.users || [];
    return apiUsers.map(user => new AdminUser(user));
  }
}
